/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

import { d } from './_utils';

import { commonProp7 } from './commonProp7';
import { commonProp5 } from './commonProp5';
import { commonProp6 } from './commonProp6';
import { commonProp4 } from './commonProp4';

export const rainwear : {[key: string]: Array<[string, string]>} = {
    p_type: [
        ["RAINCOATS_AND_RAIN_JACKETS", "Pl\u00e1\u0161tenky a bundy do da\u017e\u010fa"],
        ["RAIN_PANTS", "Nohavice do da\u017e\u010fa"],
        ["RAIN_SET", "Komplet do da\u017e\u010fa"],
        ["WATERPROOF_OVERALLS", "Nepremokav\u00e1 kombin\u00e9za, overal"],
    ],
    p_size: commonProp7,
    p_sex: commonProp5,
    p_brand: commonProp6,
    p_color: commonProp4,
};
